"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSpacingFactor = setSpacingFactor;
exports.getSpacingFactor = getSpacingFactor;
exports.setSpacingScale = setSpacingScale;
exports.getSpacingScale = getSpacingScale;
exports.calculateSpacing = calculateSpacing;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");

var _spacingScale = require("./spacingScale");

var SpacingConfig = {
  factor: 4,
  scale: _spacingScale.vdsSpacingScale
};

function setSpacingFactor(factor) {
  if (typeof factor !== 'number') {
    return console.error('The factor passed is not a number!');
  }

  SpacingConfig.factor = factor;
}

function getSpacingFactor() {
  return SpacingConfig.factor;
}

function setSpacingScale(scale) {
  if ((0, _typeof2["default"])(scale) !== 'object') {
    return console.error('The config passed is not an object!');
  }

  SpacingConfig.scale = scale;
}

function getSpacingScale() {
  return SpacingConfig.scale;
}

function calculateSpacing(unitName, unit) {
  var scale = SpacingConfig.scale,
      factor = SpacingConfig.factor;
  var num = scale[unitName] * factor;

  if (!num) {
    return console.error('Size is not supported by spacing scale!');
  }

  return unit === 'rem' ? (0, _javascriptStyleHelpers.calculateRem)(num) : "".concat(num, "px");
}


//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/theme/dist/cjs/layout/spacing/calculateSpacing.js
// module id = 1298
// module chunks = 0